import React from "react";
import Alert from 'react-bootstrap/Alert'
import DatePicker from "react-datepicker";
import { setKey } from '../../api/insurance-takers/actions'
import { setInfoKey } from '../../api/information-collection/actions'
import FileUploader from '../file-uploader';
import moment from "moment";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import is from 'date-fns/locale/is';
import { Tooltip } from "../../utils";
import CitizenshipModal from "../modals/citizenship-modal";
registerLocale('is', is)


class IdCollection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                type: '',
                number: '',
                publisher: '',
                country: '',
                start: '',
                end: '',
                cityOfBirth: '',
                occupation: '',
            },
            initialOccupation: null
        }
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeDate = this.onChangeDate.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onChangeSelectCustomerValue = this.onChangeSelectCustomerValue.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.onClickBypass = this.onClickBypass.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.validateForm = this.validateForm.bind(this)
        this.onChangeIdTypeValue = this.onChangeIdTypeValue.bind(this)
        this.onChangeCountryValue = this.onChangeCountryValue.bind(this)
        this.type = React.createRef()
        this.number = React.createRef()
        this.publisher = React.createRef()
        this.country = React.createRef()
        this.start = React.createRef()
        this.end = React.createRef()

    }

    validateForm() {
        let errors = this.state.errors
        let valid = true;
        let today = moment.utc(new Date());
        let inOneMonth = moment.utc(today).add(1, 'M');

        Object.keys(errors).forEach(key => {

            switch (key) {

                case 'type':
                    let typeValue = this.type.current.value
                    if (typeValue === '0') {
                        errors.type = 'Skilyrði að fylla út'
                        valid = false;
                    }
                    else {
                        errors.type = ''
                    }
                    break;
                case 'number':
                    let numberValue = this.number.current.value
                    if (numberValue === '') {
                        errors.number = 'Skilyrði að fylla út'
                        valid = false;
                    }
                    else {
                        errors.number = ''
                    }
                    break;
                case 'publisher':
                    let publisherValue = this.publisher.current.value
                    if (publisherValue === '') {
                        errors.publisher = 'Skilyrði að fylla út'
                        valid = false;
                    }
                    else {
                        errors.publisher = ''
                    }
                    break;
                case 'country':
                    let countryValue = this.country.current.value
                    let _type = this.type.current.value
                    if (countryValue === '') {
                        errors.country = 'Skilyrði að fylla út'
                        valid = false;
                    } else if (countryValue !== '' && _type === "1" && countryValue !== "IS") {
                        errors.country = 'Ekki er tekið á móti erlendum ökuskírteinum'
                        valid = false;
                    }
                    else {
                        errors.country = ''
                    }
                    break;
                case 'start':
                    let startValue = this.props.initialValues["issueDate"];
                    if (startValue === undefined || startValue === "" || startValue === null) {
                        errors.start = 'Skilyrði að fylla út'
                        valid = false;
                    } else if (startValue > today) {
                        errors.start = 'Útgáfudagur ekki seinna en dagurinn í dag'
                        valid = false;
                    } else {
                        errors.start = ''
                    }
                    break;
                case 'end':
                    let endValue = this.props.initialValues["validUntil"];
                    if (endValue === undefined || endValue === "" || endValue === null) {
                        errors.end = 'Skilyrði að fylla út'
                        valid = false;
                    } else if (endValue < inOneMonth) {
                        errors.end = 'Skilríki renna út áður en samningur verður gefinn út hjá Allianz í Þýskalandi'
                        valid = false;
                    } else {
                        errors.end = ''
                    }
                    break;
                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value === "false" ? false : true }, this.props.insuranceTaker))
    }

    onChangeTextInput(event) {
        // this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.insuranceTaker))
    }

    onChangeDate(id, date) {
        this.props.dispatch(setKey({ key: id, value: date }, this.props.insuranceTaker))
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.insuranceTaker))
    }

    onChangeSelectCustomerValue(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.insuranceTaker))
    }

    onClickConfirm(event) {
        let validate = this.validateForm()

        if (validate && (!this.props.initialValues['images'] || this.props.initialValues['images'].length === 0)) {
            this.setState({
                noImage: true
            })
        } else {
            this.setState({
                noImage: false
            })
        }

        if (this.props.requirePhoto && (!this.props.initialValues['images'] || this.props.initialValues['images'].length === 0)) {
            validate = false
        }

        let endValue = this.props.initialValues["validUntil"];
        let today = moment.utc(new Date());
        let inSixMonths = moment.utc(today).add(6, 'M');

        if (endValue < inSixMonths) {
            this.setState({
                expiresIn6m: true,
            })
        } else {
            this.setState({
                expiresIn6m: false,
            })
        }


        if (validate) {
            this.props.dispatch(setKey({ key: event.target.name, value: true }, this.props.insuranceTaker))
            this.props.dispatch(setKey({ key: 'submitIdLater', value: false }, this.props.insuranceTaker))
            this.props.successCallback()
        } else {
            this.props.dispatch(setKey({ key: event.target.name, value: false }, this.props.insuranceTaker))
            this.props.dispatch(setKey({ key: 'submitIdLater', value: false }, this.props.insuranceTaker))
        }
    }

    onClickBypass(event) {
        this.props.dispatch(setKey({ key: 'issuer', value: '' }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'country', value: '' }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'idType', value: '' }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'idNumber', value: '' }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'issueDate', value: null }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'validUntil', value: null }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'images', value: [] }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'useExistingPhotoId', value: null }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'confirm', value: true }, this.props.insuranceTaker))
        this.props.dispatch(setKey({ key: 'submitIdLater', value: true }, this.props.insuranceTaker))
    }

    onClickChange(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: false }, this.props.insuranceTaker))
    }

    onChangeIdTypeValue(event) {
        if (this.props.initialValues.country == 'IS') {
            if (event.target.value == "1") {
                this.props.dispatch(setKey({ key: 'issuer', value: 'Ríkislögreglustjóri' }, this.props.insuranceTaker))
            } else if (event.target.value == "2") {
                this.props.dispatch(setKey({ key: 'issuer', value: 'Þjóðskrá' }, this.props.insuranceTaker))
            }
        }
        this.onChangeSelectValue(event)
    }

    onChangeCountryValue(event) {
        if (event.target.value == 'IS') {
            if (this.props.initialValues.idType == "1") {
                this.props.dispatch(setKey({ key: 'issuer', value: 'Ríkislögreglustjóri' }, this.props.insuranceTaker))
            } else if (this.props.initialValues.idType == "2") {
                this.props.dispatch(setKey({ key: 'issuer', value: 'Þjóðskrá' }, this.props.insuranceTaker))
            }
        } else {
            this.props.dispatch(setKey({ key: 'issuer', value: '' }, this.props.insuranceTaker))
        }
        this.onChangeSelectValue(event)
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip({ html: true })
    }

    render() {
        const { customerId, initialValues, offers } = this.props

        // Setting initial dates to be able to write dates directly
        if (initialValues.issueDate === "") {
            this.props.dispatch(setKey({ key: "issueDate", value: null }, this.props.insuranceTaker))
        }
        if (initialValues.validUntil === "") {
            this.props.dispatch(setKey({ key: "validUntil", value: null }, this.props.insuranceTaker))
        }

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.country.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="addId-country" className="col-sm-6 col-form-label">
                            Land
                            {this.state.errors.country.length > 0 ?
                                <span className="error"> ({this.state.errors.country}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            {this.props.countries.data.length > 0 &&
                                <select ref={this.country} className="custom-select" id="addId-country" name="country" onChange={this.onChangeCountryValue} value={initialValues.country} disabled={initialValues.confirm}>
                                    <option value="">Veldu land skilríkis</option>
                                    {this.props.countries.data.map(c => {
                                        return <option key={c.code} value={c.code}>{c.name}</option>
                                    })}
                                </select>
                            }
                        </div>
                    </div>

                    <div className={`${this.state.errors.type.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="addId-type" className="col-sm-8 col-form-label">
                            Tegund skilríkis
                            {this.state.errors.type.length > 0 ?
                                <span className="error"> ({this.state.errors.type}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4">
                            <select ref={this.type} className="custom-select" id="addId-type" name="idType" disabled={initialValues.confirm} onChange={this.onChangeIdTypeValue} value={initialValues.idType}>
                                <option value="0">Veldu skilríki</option>
                                <option value="1">Ökuskírteini</option>
                                <option value="2">Vegabréf</option>
                            </select>
                        </div>
                    </div>

                    <div className={`${this.state.errors.number.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="addId-number" className="col-sm-6 col-form-label">
                            Númer
                            {this.state.errors.number.length > 0 ?
                                <span className="error"> ({this.state.errors.number}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            <input ref={this.number} id="addId-number" type="text" className="form-control text-right" name="idNumber" placeholder="Sláðu inn númer skilríkis" onChange={this.onChangeTextInput} value={initialValues.idNumber} disabled={initialValues.confirm} />
                        </div>
                    </div>

                    <div className={`${this.state.errors.publisher.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="addId-publisher" className="col-sm-6 col-form-label">
                            Útgefandi
                            {this.state.errors.publisher.length > 0 ?
                                <span className="error"> ({this.state.errors.publisher}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            <input ref={this.publisher} id="addId-publisher" type="text" className="form-control text-right" name="issuer" placeholder="Sláðu inn útgefanda skilríkis" onChange={this.onChangeTextInput} value={initialValues.issuer} disabled={initialValues.confirm} />
                        </div>
                    </div>

                    <div className={`${this.state.errors.start.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="addId-startingday" className="col-sm-6 col-form-label">
                            Útgáfudagur <small>(t.d. DDMMÁÁ)</small>
                            {this.state.errors.start.length > 0 ?
                                <span className="error"> ({this.state.errors.start}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            <DatePicker
                                ref={this.start}
                                selected={initialValues.issueDate}
                                id="addId-startingday"
                                className="form-control text-sm-right col-8 ml-sm-auto d-block"
                                name="issueDate"
                                onChange={(date) => this.onChangeDate("issueDate", date)}
                                value={initialValues.issueDate}
                                disabled={initialValues.confirm}
                                dateFormat={['dd.MM.yyyy', 'dd MMM yyyy', 'dd/MM/yyyy', 'ddMMyyyy', 'dd-MM-yyyy',
                                    'dd.MM.yy', 'dd MM yy', 'dd/MM/yy', 'ddMMyy', 'dd-MM-yy',]}
                                locale="is"
                            >
                            </DatePicker>
                        </div>
                    </div>

                    <div className={`${this.state.errors.end.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="addId-endday" className="col-sm-6 col-form-label">
                            Gildir til <small>(t.d. DDMMÁÁ)</small>
                            {this.state.errors.end.length > 0 ?
                                <span className="error"> ({this.state.errors.end}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            <DatePicker
                                ref={this.end}
                                selected={initialValues.validUntil}
                                id="addId-endday"
                                className="form-control text-sm-right col-8 ml-sm-auto d-block"
                                name="validUntil"
                                onChange={(date) => this.onChangeDate("validUntil", date)}
                                value={initialValues.validUntil}
                                disabled={initialValues.confirm}
                                dateFormat="dd.MM.yyyy"
                                dateFormat={['dd.MM.yyyy', 'dd MMM yyyy', 'dd/MM/yyyy', 'ddMMyyyy', 'dd-MM-yyyy',
                                    'dd.MM.yy', 'dd MM yy', 'dd/MM/yy', 'ddMMyy', 'dd-MM-yy',]}
                                locale="is"
                            >
                            </DatePicker>
                        </div>
                    </div>

                </form>
                {this.state.noImage &&
                    <Alert variant={this.props.requirePhoto ? 'danger' : 'warning'}>
                        Mynd af skilríkjum hefur ekki verið hlaðið upp.
                    </Alert>
                }
                {this.state.expiresIn6m && this.props.hasVID &&
                    <Alert variant="warning">
                        Athugið að skilríki renna út {moment.utc(initialValues.validUntil).format("DD.MM.YYYY")} og þarf mögulega að kalla eftir nýjum skilríkjum þegar Ævilífeyrir samningur er gefinn út hjá Allianz í Þýskalandi
                    </Alert>
                }
                {!initialValues.confirm &&
                    <FileUploader customerId={customerId} insuranceTaker={this.props.insuranceTaker} dispatch={this.props.dispatch} initialValues={initialValues} multiple={true} updateContract={false} disabled={initialValues.confirm} />
                }
                <div className="col-12 text-right button-container">
                    {initialValues.confirm ?
                        (<button className="btn btn-primary xs-m-10" name="confirm" onClick={this.onClickChange}> Breyta </button>) :
                        (
                            <>
                            {!this.props.requirePhoto && 
                                <button className="confirm-btn btn btn-warning xs-m-10" name="bypass" onClick={this.onClickBypass} > Skila síðar </button>
                            }
                            <button className="confirm-btn btn btn-primary xs-m-10" name="confirm" onClick={this.onClickConfirm} > Staðfesta </button>
                            </>
                        )}
                </div>
            </>
        )
    }
}

export default IdCollection

IdCollection.defaultProps = {
    requirePhoto: false,
    successCallback: () => { },
    hasVID: false
}